<template>
  <div class="l-empty" :style="{margin: margin + 'px 0'}">
    <img :src="imgSrc" alt="" :style="{width: imgWidth + 'px'}">
    <div class="tip" >{{ text }}</div>
    <div v-if="isSearch" class="search-tip">请换一个搜索词吧~</div>
    <div v-if="desc" class="search-tip">{{ desc }}~</div>
  </div>
</template>

<script>
export default {
  name: 'PtIndex',
  props: {
    text: {
      type: String,
      default: '暂无数据'
    },
    imgSrc: {
      type: String,
      default: require('@/assets/img/bj_zanwushujv.png')
    },
    imgWidth: {
      type: Number,
      default: 284
    },
    fontSize: {
      type: Number,
      default: 14
    },
    margin: {
      type: Number,
      default: 186
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    desc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.l-empty {
  text-align: center;
  img {
    height: auto;
  }
  .tip {
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-top: -34px;
    color: #0D2340;

  }
  .search-tip {
    color: #0D2340;
    // margin-top: 30px;
  }
}
</style>
